import React, {Dispatch, SetStateAction, useState} from 'react';
import styled from 'styled-components';
import {observer} from 'mobx-react-lite';
import {Modal} from '@/components/common-components';
import {Divider} from 'antd';
import {GrayButton} from '@/components/common-components/v2';

interface Props {
  visible: boolean;
  schema: any;
  setShowModal: Dispatch<SetStateAction<boolean>>;
}

export const SchemaModal = observer(({visible, schema, setShowModal}: Props) => {
  const dataList = schema ? JSON.parse(schema) : [];
  const data = (typeof (dataList) === 'object' && Object.keys(dataList).length === 0) ? [] : dataList?.find(item => item.graph) || [];
  const [expanded, setExpanded] = useState(false);
  const dataForDisplay = expanded ? data?.graph : data?.graph?.slice(0, 1);
  return (
    <Modal
      visible={visible}
      closable={true}
      onClose={() => setShowModal(false)}
      footer={<div style={{padding: '0 30px'}}><Divider /> <GrayButton onClick={() => setShowModal(false)}>Close</GrayButton></div>}>
      <ModalContentWrapper>

        <MainContainer>
          <ModalTitle>Schema.org</ModalTitle>
          {<>
            <Subtitle>@context</Subtitle>
            <Title>{data?.context ?? '-'}</Title>
            <Subtitle>@graph</Subtitle>
            {dataForDisplay?.map((item, index) => {
              return <><Subtitle>#{index + 1}</Subtitle>
                <div style={{display: 'flex', marginBottom: 25}}>
                  <LargeLine />
                  <div style={{width: '100%', overflow: 'hidden'}}>
                    {Object.entries(item)?.map(x => {
                      return <>
                        <Subtitle style={{textTransform: 'capitalize'}}>{`${x[0]}`}</Subtitle>
                        {`${x[0]}` == 'potentialAction' ? '' : (`${x[0]}` == 'url' ? <URL>{`${x[1]}`}</URL> :
                          <Title>{`${typeof(x[1])!=='object' ? x[1] : '-'}`}</Title>)}
                        {`${x[0]}` == 'potentialAction' ? item.potentialAction?.length > 0 && item?.potentialAction?.map((z, id) => {
                          return <div key={`potentialActionId_${id}`} style={{display: 'flex', wordBreak: 'break-word'}}>
                            <LargeLine />
                            <div>
                              <Subtitle>{z?.type}</Subtitle>
                              <Title>{z?.queryInput}</Title>
                            </div>
                          </div>;
                        }) : ''}
                      </>;
                    })}
                  </div>
                </div></>;
            })}
            {data?.graph?.length > 1 ? <div style={{marginLeft: 20}}>
              <URL onClick={() => setExpanded(!expanded)}>
                {expanded ? 'Hide schema' : 'Show full schema'}
              </URL></div> : ''}
          </>}
        </MainContainer>
      </ModalContentWrapper>
    </Modal>

  );
});

const MainContainer = styled.div`
  width: 100%;
  padding: 25px;
  background: #FFFFFF;
`;

const Title = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #121212;
  flex-wrap: nowrap;
  white-space: pre-wrap;
  word-break: break-word;
`;
const Subtitle = styled.div`
  font-weight: 300;
  font-size: 14px;
  line-height: 22px;
  color: #4E5156;
  margin-top: 10px;
  word-break: break-word;
`;
const LargeLine = styled.div`
  width: 2px;
  height: auto;
  background: #E8E8E8;
  border-radius: 6px;
  margin-right: 9px;
`;
const URL = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #2D6CCA;
  cursor: pointer;
  flex-wrap: nowrap;
  white-space: pre-wrap;
  word-break: break-word;
`;

const ModalContentWrapper = styled.div`
  max-height: 70vh;
  overflow-y: auto;
  margin-top: 10px;
  // border: 1px solid #E8E8E8;
  // border-radius: 8px;
`;

const ModalTitle = styled.div`
  font-weight: 600;
  font-size: 20px;
`;
